import defaultRedaxios from "redaxios";

export async function saveToken(token: string): Promise<void> {
  await defaultRedaxios.post("/api/auth", { token });
}

export async function deleteToken(): Promise<void> {
  await defaultRedaxios.delete("/api/auth");
}
